export const FLAG_IMG_BY_COUNTRY = new Set([
    'au',
    'bg',
    'br',
    'ca',
    'ch',
    'cn',
    'cz',
    'de',
    'es',
    'fr',
    'gb',
    'hu',
    'il',
    'in',
    'it',
    'jp',
    'kr',
    'nl',
    'pl',
    'ro',
    'se',
    'sg',
    'tr',
    'us',
]);
